


























































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Company } from '@/api/model/company'
import { User } from '@/api/model/user'
import { CompanyAPI, LicenseAPI, UserAPI } from '@/api/backend-client'
import ListContainer from '@/components/ui/list/ListContainer.vue'
import ListItem, { ListItemClickEvent } from '@/components/ui/list/list-item/ListItem.vue'
import ListItemClickIndicator from '@/components/ui/list/list-item/ListItemClickIndicator.vue'
import ListItemLabel from '@/components/ui/list/list-item/ListItemLabel.vue'
import EditStatusReasonForm from '@/components/form/EditStatusReasonForm.vue'
import EditCompanyForm from '@/components/form/EditCompanyForm.vue'
import EditCompanyLicenseForm from '@/components/form/EditCompanyLicenseForm.vue'
import moment from 'moment/moment'
import BlockContainer from '@/components/ui/blocks/BlockContainer.vue'
import IconArrow from '@/components/icons/IconArrow.vue'
import IconArrowDoubleRight from '@/components/icons/IconArrowDoubleRight.vue'
import IconSpouse from '@/components/icons/IconSpouse.vue'
import ListItemAction from '@/components/ui/list/list-item/ListItemAction.vue'
import IconMagnifyingGlass from '@/components/icons/IconMagnifyingGlass.vue'
import { UserType } from '@/api/types'

@Component({
    components: {
        IconMagnifyingGlass,
        ListItemAction,
        IconSpouse,
        IconArrowDoubleRight,
        IconArrow,
        BlockContainer,
        EditCompanyLicenseForm,
        EditCompanyForm,
        EditStatusReasonForm,
        ListItemLabel,
        ListItemClickIndicator,
        ListItem,
        ListContainer,
    },
})
export default class CompanySettingsLicense extends Vue {
    @Prop() user!: User
    companies: Company[] = []
    activeCompany: Company = null
    loading: boolean = false
    newCompanyLicense = false
    companyFilter = ''
    userFilter = ''

    get sortedCompanyUsers() {
        let users

        if (!this.userFilter) {
            users = this.activeCompany.users.slice()
        } else {
            users = this.activeCompany.users.filter(user => {
                return user.name.toLowerCase().includes(this.userFilter.toLowerCase())
            })
        }

        return users
            .filter(user => user.type === UserType.DEFAULT)
            .sort((a, b) => a.name.localeCompare(b.name))
    }

    get filteredCompanies() {
        if (!this.companyFilter) {
            return this.companies
        }

        return this.companies.filter(company => company.name.toLowerCase().includes(this.companyFilter.toLowerCase()))
    }

    get activeCompanyId(): null | string {
        return this.activeCompany?.id
    }

    async mounted(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.companies = (await CompanyAPI.getAll()).sort((a, b) => {
            return a.name.localeCompare(b.name)
        })
        this.loading = false
    }

    formatDate(date: Date) {
        return moment(date).format('DD MMMM YYYY')
    }

    companyItemClicked(event: ListItemClickEvent<Company>) {
        if (event.item.id !== this.activeCompany?.id) {
            this.activeCompany = event.item
        } else {
            this.activeCompany = null
        }
    }

    companyItemClose() {
        this.activeCompany = null
    }

    createCompanyLicense() {
        this.newCompanyLicense = true
    }

    async impersonate(user: User) {
        await UserAPI.loginImpersonate(user.id)
        window.location.replace('/dashboard')
    }
}
